//Module Keys
let locales = {};

//Merge Views
import login from 'Core/views/login/lan/en';
locales = { ...locales, ...login };

import loginSocialMedia from 'Core/views/loginSocialMedia/lan/en';
locales = { ...locales, ...loginSocialMedia };

import forgotPasswordOld from 'Core/views/login/.components/forgotPassword/lan/en';
locales = { ...locales, ...forgotPasswordOld };

import changePassword from 'Core/containers/Header/.components/changePassword/lan/en';
locales = { ...locales, ...changePassword };

import forceChangePassword from 'Core/views/login/.components/chagePassword/lan/en';
locales = { ...locales, ...forceChangePassword };

import menuAccount from 'Core/containers/Header/.components/menuAccount/lan/en';
locales = { ...locales, ...menuAccount };

import confirmUser from 'Core/views/confirmUser/lan/en';
locales = { ...locales, ...confirmUser };

import forgotPassword from 'Core/views/forgotPassword/lan/en';
locales = { ...locales, ...forgotPassword };

import logoutPrompt from 'Core/containers/Header/.components/logoutPrompt/lan/en';
locales = { ...locales, ...logoutPrompt };

export default locales;